import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue'
import RadioButtonQuestion from '@/components/InterviewQuestionary/Questions/RadioButtonQuestion.vue'
import UploadFilesQuestion from '@/components/InterviewQuestionary/Questions/UploadFilesQuestion/UploadFilesQuestion.vue'
import TextQuestion from '@/components/InterviewQuestionary/Questions/TextQuestion.vue'
import EmailQuestion from '@/components/InterviewQuestionary/Questions/EmailQuestion.vue'
import PhoneNumberQuestion from './Questions/PhoneNumberQuestion.vue'
import CheckboxQuestion from '@/components/InterviewQuestionary/Questions/CheckboxQuestion.vue'
import LocationQuestion from '@/components/InterviewQuestionary/Questions/LocationQuestion.vue'
import DropDownQuestion from '@/components/InterviewQuestionary/Questions/DropDownQuestion.vue'
import { InterviewQuestionResponseModel } from '@/models/QuestionModels'
import CalendarQuestion from './Questions/CalendarQuestion.vue'
import { useInterviewStore } from '@/stores/interviewStore'
import { QuestionType } from '@/models/QuestionType'
import RadioButtonThemeQuestion from './Questions/RadioButtonThemeQuestion.vue'
import type { Component } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'InterviewQuestionsList',
  props: {
    questions: null
  },
  setup(__props: any) {



const QuestionsMapping: { [key in QuestionType]: Component } = {
    [QuestionType.UploadFilesQuestion]: UploadFilesQuestion,
    [QuestionType.CategoryQuestion]: RadioButtonThemeQuestion,
    [QuestionType.RadioButtonThemeQuestion]: RadioButtonThemeQuestion,
    [QuestionType.RadioImageQuestion]: RadioButtonQuestion,
    [QuestionType.RadioButtonQuestion]: RadioButtonQuestion,
    [QuestionType.TextQuestion]: TextQuestion,
    [QuestionType.RichTextQuestion]: TextQuestion,
    [QuestionType.NameQuestion]: TextQuestion,
    [QuestionType.EmailQuestion]: EmailQuestion,
    [QuestionType.PhoneQuestion]: PhoneNumberQuestion,
    [QuestionType.CalendarQuestion]: CalendarQuestion,
    [QuestionType.UploadMultipleFilesComponent]: CalendarQuestion,
    [QuestionType.CheckboxQuestion]: CheckboxQuestion,
    [QuestionType.LocationQuestion]: LocationQuestion,
    [QuestionType.DropDownQuestion]: DropDownQuestion,
}

const interviewStore = useInterviewStore()
const questionIndex = computed(() => interviewStore.questionIndex)

function isShown(index: number, q: InterviewQuestionResponseModel) {
    return index <= questionIndex.value && !q.hideQuestion;
}

function resolveQuestion(qst: InterviewQuestionResponseModel) {
    try {
        return QuestionsMapping[qst.Type];
    } catch (erro) {
        console.warn((erro as Error).message)
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.questions, (model, index) => {
    return (_openBlock(), _createElementBlock(_Fragment, {
      key: model.Id
    }, [
      (isShown(index, model))
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(resolveQuestion(model)), {
            key: 0,
            id: model.Id,
            question: model,
            isStandAlone: true
          }, null, 8, ["id", "question"]))
        : _createCommentVNode("", true)
    ], 64))
  }), 128))
}
}

})